module.exports = __webpack_public_path__ + "static/media/AiBased.025d5e80.svg";